<div class="account-form-wrapper">
  <form
    [hidden]="startRegistraionShowNIC"
    class="form user-login-form user-form v-row"
    #form="ngForm"
    [formGroup]="signinForm"
    (ngSubmit)="onSignin(form)"
    novalidate
  >
    <div class="row">
      <div class="col inner-fields">
        <h1 class="signin-title">Admin Log In</h1>
        <div class="item-fields">
          <div class="form-group m-t-xl">
            <input
              formControlName="username"
              type="email"
              inputmode="email"
              autocomplete="username"
              autocapitalize="off"
              spellcheck="false"
              class="form-control"
              id="username"
              placeholder="Enter your Email"
            />
            <div
              [hidden]="signinForm.controls['username'].valid || (!form.submitted && !signinForm.controls.username.touched)"
              class="alert alert-danger"
            >
              <span [hidden]="!signinForm.controls.username.errors?.email">Email is invalid.</span>

              <span [hidden]="!signinForm.controls.username.errors?.required">Email is Required</span>
            </div>
          </div>
          <div class="form-group">
            <div class="pw-wrapper">
              <input
                formControlName="password"
                type="{{ (changePWType && 'text') || 'password' }}"
                autocapitalize="off"
                spellcheck="false"
                autocomplete="current-password"
                class="form-control"
                id="password"
                placeholder="Enter your CAL Portal password"
              />

              <span class="float-end m-0 show-password">
                <button id="btn-view" aria-label="password-preview" type="button" class="btn-link" (click)="displayPassword()">
                  <i class="fa fa-eye"></i>
                </button>
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="text-end">
                <a class="forgot-pw" routerLink="/admin-reset-password">Forgot Password?</a>
              </div>
              <!--error msg-->
              <div [hidden]="signinForm.controls['password'].valid || !form.submitted" class="alert alert-danger mb-1">
                <span [hidden]="!signinForm.controls.password.errors?.required">Enter CAL Portal password</span>
                <span [hidden]="!signinForm.controls.password.errors?.password">Password is Invalid</span>
              </div>
            </div>
          </div>
          <div class="form-group m-0">
            <div class="recaptchaSlide" [slide]="showRecaptcha">
              <custom-captcha
                [control]="signinForm.get('captchaText')"
                placeholder="Type the text"
                label="Enter CAPTCHA text shown in the image"
                [showErrors]="form.submitted"
                (captchaRequest)="captchaRequest($event)"
                [resetOnError]="resetOnError"
              >
                <span [hidden]="!signinForm.get('captchaText').errors?.required">The CAPTCHA field is required</span>
              </custom-captcha>
            </div>
          </div>
          <div class="form-group mt-0 mb-0">
            <app-primary-button text="Sign In Securely" [loading]="siginingInProgress" type="submit" [fullWidth]="true">
            </app-primary-button>
          </div>
          <errors style="position: relative; top: 10px" [on]="signinFormErrors">
            {{ signinFormErrors }}
          </errors>
          <!-- <div [hidden]="(startRegistraionShowNIC ||signinForm.controls['username'].valid || (!form.submitted))" class="alert alert-danger">
            <span [hidden]="!signinForm.controls.username.errors?.required">Enter your NIC number or Passport Number</span>
          </div> -->
        </div>
      </div>
    </div>
  </form>
  <div class="powered-by text-center">
    <div>
      Powered by
      <a href="https://cal.lk" target="_blank">CAL</a> | <a href="/terms-and-conditions">Disclaimer</a>
    </div>
  </div>
</div>
